import {Route, Switch} from "react-router-dom";
import React from "react";
import ProjectsSobigdata from "./sobigdata";

function projectsWebpagesMappings() {
    // TODO: Create mappings for more project pages here
    return [<Route path="/projects/pages" component={ProjectsSobigdata} />];
};

export default projectsWebpagesMappings;
